import React, { useRef } from "react"
import { Formik, Form } from "formik"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    InputLabel,
    Stack,
    TextField,
    styled,
} from "@mui/material"
import * as Yup from "yup"
import { COLORS, getTimezoneDate } from "../../utils"
import dayjs from "dayjs"
import { DatePicker } from "@mui/x-date-pickers"

const schema = Yup.object().shape({
    startDate: Yup.string(),
    endDate: Yup.string()
}).test(
    "at-least-one",
    "Veuillez sélectionner au moins une date",
    (values) => !!values.startDate || !!values.endDate
)

const sx = {
    title: {
        color: "#7C7C7C",
        fontSize: 16,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: 1.37,
    }
}

const StyledDialog = styled(Dialog)({
    "& .MuiPaper-root": {
        width: 468,
        padding: 10
    }
})


const DateRangeDialogForm = ({ open, onClose, onConfirm, title, description= "Choisissez une date de début et/ou une date de fin" }) => {
    const formikRef = useRef()
    const handleConfirm = () => {
        formikRef.current?.submitForm()
    }

    const handleCancel = () => onClose()

    const handleSubmit = (values) => {
        onConfirm(values)
        onClose()
    }

    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle sx={{ ...sx.title, fontSize: 18, fontWeight: 500, color: COLORS.BLACK800, paddingBottom: 0 }}>
                {title}
            </DialogTitle>
            <DialogTitle sx={sx.title}>
                {description}
            </DialogTitle>
            <DialogContent sx={{ mt: 1 }}>
                <Formik
                    innerRef={formikRef}
                    onSubmit={handleSubmit}
                    initialValues={{
                        startDate: getTimezoneDate(dayjs.utc().startOf("day")),
                        endDate: getTimezoneDate(dayjs.utc().endOf("day"))
                    }}
                    validateOnBlur={false}
                    validateOnChange={false}
                    validationSchema={schema}>
                    {({ values, setFieldValue, errors }) => {
                        return (
                            <Form>
                                <Stack gap={5} direction="row">
                                    <Stack>
                                        <InputLabel>Date de début</InputLabel>
                                        <DatePicker
                                            showToolbar={false}
                                            value={values.startDate}
                                            name="startDate"
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} variant="standard" error={!!errors.productionDate} InputLabelProps={{ shrink: true }} />}
                                            onChange={(date) => {
                                                setFieldValue("startDate", getTimezoneDate(date))
                                            }}
                                        />
                                    </Stack>
                                    <Stack>
                                        <InputLabel>Date de fin</InputLabel>
                                        <DatePicker
                                            showToolbar={false}
                                            value={values.endDate}
                                            name="endDate"
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} variant="standard" error={!!errors.productionDate} InputLabelProps={{ shrink: true }} />}
                                            onChange={(date) => {
                                                setFieldValue("endDate", getTimezoneDate(date))
                                            }}
                                        />
                                    </Stack>
                                </Stack>
                            </Form>
                        )
                    }}
                </Formik>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={handleCancel} color="primary">
                    Annuler
                </Button>
                <Button onClick={handleConfirm} color="primary" variant="contained">
                    VALIDER
                </Button>
            </DialogActions>
        </StyledDialog>
    )
}

export default DateRangeDialogForm
